import React from 'react'
import './SentReceiveMessage.css';
import UserIcon from '../../../assets/images/user-icon3.png';

import MessageComponent from '../../../components/MessageComponent';

const ReceivedMessage = ({message} ) => {
    return (
        <div className='received-message'>
            <div className='received-message-container'>
                <div className='received-message-image'>
                    <div className='received-message-image2'>
                        <img src={UserIcon} alt='icon' />
                    </div>
                </div>
                {/* <div className='received-message-text '>{message} </div> */}
                <MessageComponent message={message} msgType="received" />
            </div>
            <p className='received-message-time mt-1'>10:56 AM</p>
        </div>
    )
}

export default ReceivedMessage
